var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29 11.29C8.10069 11.4778 7.9942 11.7334 7.9942 12C7.9942 12.2666 8.10069 12.5222 8.29 12.71L11.29 15.71C11.4778 15.8993 11.7334 16.0058 12 16.0058C12.2666 16.0058 12.5222 15.8993 12.71 15.71L15.71 12.71C16.1021 12.3179 16.1021 11.6821 15.71 11.29C15.3179 10.8979 14.6821 10.8979 14.29 11.29L13 12.59V3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.59L9.71 11.29C9.52223 11.1007 9.26664 10.9942 9 10.9942C8.73336 10.9942 8.47777 11.1007 8.29 11.29ZM18 7H16C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9H18C18.5523 9 19 9.44772 19 10V17C19 17.5523 18.5523 18 18 18H6C5.44772 18 5 17.5523 5 17V10C5 9.44772 5.44772 9 6 9H8C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7H6C4.34315 7 3 8.34315 3 10V17C3 18.6569 4.34315 20 6 20H18C19.6569 20 21 18.6569 21 17V10C21 8.34315 19.6569 7 18 7Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default ForwardRef;